export default "__VITE_ASSET__G3K9$8BX__"